/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manage_Flavors_DescriptionInputs */

const en_manage_flavors_description = /** @type {(inputs: Manage_Flavors_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add, edit, or remove flavor notes.`)
};

const es_manage_flavors_description = /** @type {(inputs: Manage_Flavors_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agrega, edita o elimina notas de sabor.`)
};

/**
* | output |
* | --- |
* | "Add, edit, or remove flavor notes." |
*
* @param {Manage_Flavors_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const manage_flavors_description = /** @type {((inputs?: Manage_Flavors_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manage_Flavors_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_manage_flavors_description(inputs)
	return es_manage_flavors_description(inputs)
});